import { TaskState } from "gql/graphql"

export const canEditTaskInfo = (task: any) => {
  const allowedStates = [
    TaskState.Draft,
    TaskState.Incomplete,
    TaskState.Cache
  ];
  
  return allowedStates.includes(task.state);
}